var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isQuizOnline && _vm.showQuiz
    ? _c(
        "div",
        {
          staticClass: "osfQuizWrapper ti-font-regular",
          attrs: { id: "osfquiz-" + _vm.qid },
        },
        [
          _c("loadercomp", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.jsonLoading && !_vm.error,
                expression: "jsonLoading && !error",
              },
            ],
          }),
          _vm._v(" "),
          _c("errorcomp", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.error,
                expression: "error",
              },
            ],
          }),
          _vm._v(" "),
          !_vm.jsonLoading && !_vm.error && _vm.showWelcomePage
            ? _c("div", [_c("welcomecomp")], 1)
            : _vm._e(),
          _vm._v(" "),
          !_vm.error && _vm.showProductsPage
            ? _c("div", [_c("showproductscomp")], 1)
            : _vm._e(),
          _vm._v(" "),
          !_vm.error && _vm.showEndPage
            ? _c("div", [_c("thankyoucomp")], 1)
            : _vm._e(),
          _vm._v(" "),
          !_vm.error && _vm.showPrivatePage
            ? _c("div", [_c("privatecomp")], 1)
            : _vm._e(),
          _vm._v(" "),
          !_vm.jsonLoading &&
          !_vm.error &&
          !_vm.showWelcomePage &&
          !_vm.jsonLoading &&
          !_vm.error &&
          !_vm.showEndPage &&
          !_vm.showPrivatePage &&
          !_vm.showProductsPage
            ? _c("div", [
                _vm.externalurlcomp
                  ? _c(
                      "div",
                      [
                        _c("externalurlcomp", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.externalurlcomp,
                              expression: "externalurlcomp",
                            },
                          ],
                        }),
                      ],
                      1
                    )
                  : _vm.categorycomp
                  ? _c(
                      "div",
                      [
                        _c("categorycomp", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.categorycomp,
                              expression: "categorycomp",
                            },
                          ],
                        }),
                      ],
                      1
                    )
                  : _vm.quickviewcomp
                  ? _c(
                      "div",
                      [
                        _c("quickviewcomp", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.quickviewcomp,
                              expression: "quickviewcomp",
                            },
                          ],
                        }),
                      ],
                      1
                    )
                  : _vm.showproductscarouselcomp.length > 0 ||
                    _vm.showRecommendations
                  ? _c(
                      "div",
                      [
                        _c("showproductscarouselcomp", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showproductscarouselcomp,
                              expression: "showproductscarouselcomp",
                            },
                          ],
                        }),
                      ],
                      1
                    )
                  : _c("div", [_c("questioncomp")], 1),
              ])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }